<template>
  <div>
    <lc-login class="lc-login" v-bind="loginConfig" @onLogin="onLogin">
      <div slot="lcProtocol" class="login-protocol">
        <span>登录即表示您已阅读并同意</span>
        <span class="login-protocol_link" @click="jumpPortal('user')"
          >用户协议</span
        >
        <span>和</span>
        <span class="login-protocol_link" @click="jumpPortal('privacy')"
          >隐私政策</span
        >
      </div>
    </lc-login>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { login } from '@/utils/mixin'

export default {
  name: 'LoginForm',
  data() {
    return {
      loginConfig: {
        hideRemember: true,
        accountPlaceholder: '账户/密码', // 账户输⼊框Placeholder
        plats: [],
        showProtocol: false, // 是否显示用户协议，如果为false,可通过lcProtocol插槽自定义
        thirdList: [],
        // thirdList: [{ id: 'qywx', name: '企业微信' }],
        accountOnly: false, // 是否只支持账号密码登录
        noRenter: false, // 不展示选择租户选项
        source: 5001, // 来源,后端定，必填
        loginRoute: '', // 登录页面的path，默认不填
        unUserInfo: false, // 是否需要获取⼈员详细信息，默认不填
        onlyReset: false, // 仅显示修改密码
        loginTabs: [
          { id: 1, text: '密码登录' },
          { id: 2, text: '验证码登录' }
        ],
        systemTerminalFlag: 'ca1cc15225d34e4fa4c928f3e916c03f'
      }
    }
  },
  mixins: [login],
  computed: {
    ...mapGetters(['microApps'])
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      const { microApps } = this
      for (const key in microApps) {
        if (!microApps?.[key]?.app?.unmount) return
        microApps[key].app.unmount()
      }
    },
    async onLogin(userinfo) {
      this.$message.success('登录成功')
      console.log(userinfo)
      const { Login, successLogin } = this
      Login(userinfo).then(() => successLogin(userinfo))
    },
    // 跳转隐私协议等
    jumpPortal(msg) {
      const url = document.location.origin + '/portal-web/docs/' + msg
      window.open(url, '_blank')
    }
  }
}
</script>
<style lang="less" scoped>
.lc-login ::v-deep {
  .login-protocol_link {
    color: #00a497!important;
  }
  .login-top-tabs .tab-item.active:after {
    background-color: #00a497;
  }
  .lc-fetch-code .fetchCode .sendCode {
    color: #00a497;
  }
  .lc-account-login .forget-password {
    color: #00a497;
  }
  .lc-reset-passwords {
    .reset-exit {
      color: #00a497;
    }
    .progress-tip {
      .tip-content {
        .step {
          &.active {
            .dot-div {
              background-color: #00a497;
            }
            .text-div {
              color: #00a497;
            }
          }
        }
      }
    }
  }
}
</style>
